const API_URL = {
	google: 'https://www.googleapis.com/books/v1/volumes?q=',
	url: 'https://immense-forest-66043-666d8f8c117a.herokuapp.com/',
	local: 'http://localhost:8000/',
	author: '+inauthor:',
	title: '+intitle:',
	genre: '+insubject:',
};


export default API_URL;